const en = {
    home: 'home',
    product: 'product',
    brand: 'brand',
    about: 'about',
    ioofox: 'Ioofox',
    searchContent: 'search content',
    search: 'search',
    ioofoxPlatform: 'ioofox open platform',
    application: 'application',
    brandDynamic: 'brand dynamic',
    noData: 'no data',
    downloads: 'downloads',
    ranking: 'ranking',

}
export default en;


// WEBPACK FOOTER //
// ./src/language/en.js